import { useContext } from 'react'

import { PricingContext, type IPricingContext } from './PricingContext'

const usePricingContext = (): IPricingContext => {
  const { isInitialized, pricingContextModule } = useContext(PricingContext)

  return {
    isInitialized,
    pricingContextModule,
  }
}

export default usePricingContext
